/**
 * CZNA-217 — the field catalog of the query line, from
 * GET /czna-authorities/records/field-query/fields: every tag the semantic catalog
 * knows, with its Czech label and subfields. The backend validates addresses against
 * the same catalog, so what the line accepts and what the server accepts cannot drift.
 *
 * <p>Loaded only while the line is open (`enabled`), and cached for the session — the
 * catalog changes with a deploy, not with use.
 */
import { useQuery } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { fetchFieldQueryCatalog } from '../api/recordService';
var FIELD_QUERY_CATALOG_KEY = 'czna-authorities-field-query-catalog';
export var useFieldQueryCatalog = function (enabled) {
    var ky = useOkapiKy();
    var _a = useQuery([FIELD_QUERY_CATALOG_KEY], function () { return fetchFieldQueryCatalog(ky); }, { enabled: enabled, staleTime: Infinity }), data = _a.data, isLoading = _a.isLoading, isError = _a.isError;
    return { catalog: data, isLoading: isLoading, isError: isError };
};
